import { Component, ElementRef, Input, OnDestroy } from '@angular/core';
import { ProjectsFacade, SharedFacade, UserDetailsFacade, customEncode } from '@piqet-angular/data';
import { ColDef } from 'ag-grid-community';
import { ActionButtonComponent } from 'libs/ui/src/lib/action-button/action-button.component';
import { GridMyProjectImageComponent } from 'libs/ui/src/lib/grid-my-project-image/grid-my-project-image.component';
import { GridProjectLinkComponent } from 'libs/ui/src/lib/grid-project-link/grid-project-link.component';
import { ProjectsDataGridService } from '../projects-data-grid.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ProjectsService } from 'libs/data/src/lib/services/projects/projects.service';
import { CustomModalService, packagingSubMenu } from '@piqet-angular/shared';
import { catchError, of, finalize, Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { DomRefService } from 'ngx-joyride';
import { HttpClient } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { SharedService } from 'libs/data/src/lib/services/shared/shared.service';
@Component({
  selector: 'piqet-angular-packaging-projects',
  templateUrl: './packaging-projects.component.html',
  styleUrls: ['./packaging-projects.component.css'],
})
export class PackagingProjectsComponent implements OnDestroy {
  @Input() eleId: any;
  @Input() stepsArray: any;
  @Input() stepCount: any;
  @Input() stepTitle: any;
  @Input() stepText: any;

  isProjectTab = false;
  columnDefs!: ColDef[];
  event: any;
  activatedRoute: any;
  countryList: any;
  gridName = 'Dashboard Project';
  frameworkComponents = {
    actionRenderer: ActionButtonComponent,
    GridMyProjectImageComponent: GridMyProjectImageComponent,
    GridProjectLinkComponent: GridProjectLinkComponent,
  };
  packagingProjects: any;
  deleteProjectData: Subscription;
  copyProjectData: Subscription;
  hideUnhideSubject: Subscription;
  createAccess = true;
  organizationNames: any;
  userRole: string = '';

  constructor(
    public projectFacde: ProjectsFacade,
    public sharedFacade: SharedFacade,
    private projectsDataGridService: ProjectsDataGridService,
    public route: ActivatedRoute,
    private projectService: ProjectsService,
    private modal: CustomModalService,
    private toaster: ToastrService,
    private router: Router,
    private http: HttpClient,
    public userDetailsFacade: UserDetailsFacade,
    private cookieService: CookieService,
    private sharedService: SharedService
  ) {
    this.activatedRoute = this.route.snapshot.routeConfig?.path;
    if (window.location.href.includes('projects')) {
      this.isProjectTab = true;
    }
    const userRole = this.cookieService.get('u_type');
    this.userRole = this.sharedService.decodeURIComponentParam(userRole)?.toLowerCase();
    this.columnDefs = this.isProjectTab
      ? this.projectsDataGridService.getProjectsTabDataColumn(this.activatedRoute, this.userRole)
      : this.projectsDataGridService.getDashboardProjectsDataColumn(this.activatedRoute);
    this.createAccess = this.projectsDataGridService.isProjectAccess(
      this.activatedRoute,
      packagingSubMenu
    )
      ? this.projectsDataGridService.isProjectAccess(this.activatedRoute, packagingSubMenu)
          ?.isCreate
      : true;
    this.activatedRoute == 'admin-projects'
      ? this.getPackagingProjectsAdmin()
      : this.getPackagingProjects();
    this.deleteProjectData = this.projectsDataGridService.deleteProjectData$.subscribe(
      (deleteData: any) => {
        this.deletePackagingProject(deleteData[0]);
      }
    );

    this.copyProjectData = this.projectsDataGridService.copyProjectData$.subscribe(
      (copyData: any) => {
        this.copyProject(copyData[0], copyData[1]);
      }
    );
    this.hideUnhideSubject = this.projectsDataGridService.hideUnhideSubject$.subscribe(
      (data: any) => {
        this.hideUnhideSubData(data);
      }
    );
  }

  ngOnInit(): void {
    this.sharedFacade.getCountryList();
    this.loadComingSoonText();
    this.sharedFacade.countryList$.subscribe(data => {
      this.countryList = data;
    });
  }

  getPackagingProjects() {
    this.projectService
      .getMyAllProjectList()
      .pipe(finalize(() => {}))
      .subscribe((res: any) => {
        this.packagingProjects = res.data;
      });
  }

  getPackagingProjectsAdmin() {
    this.projectService.getMyAllProjectListAdmin().subscribe((res: any) => {
      this.packagingProjects = res.data;
    });
  }

  async addNewProject(id: any, label: any) {
    let response = await this.projectService.getMyAllProjectModalData(id);
    this.modal.invoke('newMyProjects', {
      initialState: {
        newMyProjects: response.data,
        pathName: this.activatedRoute,
        label: label,
        processColDef: this.projectsDataGridService.getNewDefaultSettingColumn(),
      },
      class: 'modal-xl',
    });
    this.modal.ref?.content.saveNewMyProjectEvent.subscribe((saveNewMyProjectEvent: any) => {
      this.addUpdatePackagingProject(saveNewMyProjectEvent);
    });
  }

  async copyProject(projectId: any, label: any) {
    let copyResponse = await this.projectService.getMyAllProjectModalDataForCopy(projectId);
    this.modal.invoke('newCopyMyProjectModal', {
      initialState: {
        newMyProjects: copyResponse.data,
        pathName: this.activatedRoute,
        label: label,
      },
      class: 'modal-xl',
    });
    this.modal.ref?.content.saveNewCopyMyProjectEvent.subscribe(
      (saveNewCopyMyProjectEvent: any) => {
        this.copyPackagingProject(saveNewCopyMyProjectEvent);
      }
    );
  }

  addUpdatePackagingProject(data: any) {
    this.projectService
      .addEditMyAllProjectData(data)
      .pipe(
        catchError((error: any) =>
          of(this.toaster.error('An error occurred. Please try again later.'))
        ),
        finalize(() => {
          this.modal.close();
          this.activatedRoute == 'admin-projects'
            ? this.getPackagingProjectsAdmin()
            : this.getPackagingProjects();
        })
      )
      .subscribe(res => {
        res.messageType ? this.toaster.error(res.message) : this.toaster.success(res.message);
        if (
          this.projectsDataGridService.isAccess(this.activatedRoute, 'packaging').isView ||
          this.projectsDataGridService.isAccess(this.activatedRoute, 'packaging').isEdit
        ) {
          const encodedValue = encodeURIComponent(res.data);
          this.router.navigate([
            'projects/projects-setting',
            customEncode(btoa(encodedValue)),
            'setting',
          ]);
        }
      });
  }

  copyPackagingProject(data: any) {
    this.projectService
      .copyMyAllProjectData(data)
      .pipe(
        catchError((error: any) =>
          of(this.toaster.error('An error occurred. Please try again later.'))
        ),
        finalize(() => {
          this.activatedRoute == 'admin-projects'
            ? this.getPackagingProjectsAdmin()
            : this.getPackagingProjects();
          this.modal.close();
        })
      )
      .subscribe(res => {
        res.messageType ? this.toaster.error(res.message) : this.toaster.success(res.message);
      });
  }

  deletePackagingProject(data: any) {
    this.projectService
      .deleteMyAllProjectList(data.projectId)
      .pipe(
        catchError((error: any) =>
          of(this.toaster.error('An error occurred. Please try again later.'))
        ),
        finalize(() => {
          this.activatedRoute == 'admin-projects'
            ? this.getPackagingProjectsAdmin()
            : this.getPackagingProjects();
        })
      )
      .subscribe(res => {
        res.messageType ? this.toaster.error(res.message) : this.toaster.success(res.message);
      });
  }

  hideUnhideSubData(data: any) {
    this.projectService
      .UpdateProjectVisibility(data.projectId, !data.isProjectVisible)
      .pipe(
        catchError((error: any) =>
          of(this.toaster.error('An error occurred. Please try again later.'))
        )
      )
      .subscribe(res => {
        if (res.messageType && data) {
          this.toaster.error(res.message);
        } else {
          this.toaster.success(res.message);
          this.activatedRoute == 'admin-projects'
            ? this.getPackagingProjectsAdmin()
            : this.getPackagingProjects();
        }
      });
  }

  onPrevStep() {
    this.router.navigate([`/dashboard`]);
  }

  redirectToImportProject() {
    this.router.navigate([`/organization-report/import-piqet-template`]);
  }

  loadComingSoonText(): void {
    this.http.get<any[]>('../../../assets/json/access-control.json').subscribe(
      (data: any) => {
        this.organizationNames = data?.organizationNames?.split(':');
      },
      (error: any) => {
        console.error('Error loading coming soon:', error);
      }
    );
  }

  ngOnDestroy() {
    this.deleteProjectData.unsubscribe();
    this.copyProjectData.unsubscribe();
    this.hideUnhideSubject.unsubscribe();
  }
}
